<template>
    <div>
        <div id="exportable-content">
            <Hero title="General Data Protection Regulation (GDPR)" colour-index="4"
                subtitle="Date of last revision: Feb 19, 2026" :left="true" />

            <!-- <SubTitle title="General Data Procection Regulation (GDPR)" /> -->
            <!-- <p>Last update: Feb 19, 2026</p> -->
            <div class="px-3 sm:px-28 sm:mt-12 sm:pb-12 text-[var(--black)]">
                <p>
                    Unified is serious about security (<a class="underline"
                        href="/security">https://unified.to/security</a>). To support our customers that collect
                    and process the personal data of European citizens, Unified has implemented the required controls and
                    procedures to comply with the obligations
                    of a data
                    <Badge label="sub-processor" /> under the GDPR.
                </p>

                <h6>GDPR Classification</h6>
                <p>Data Sub-Processor</p>

                <h6>Individual in charge of GDPR compliance</h6>
                <p>Alexey Adamsky, CTO</p>

                <h6>Data Protection Officer</h6>
                <p>Alexey Adamsky, CTO</p>

                <h6>Purpose of Processing</h6>
                <p>To enable our API integration service in our customers' applications, who themselves are classified as
                    data
                    processor in the GDPR. For additional
                    details, see our Privacy Policy (<a href="/privacy" class="underline">https://unified.to/privacy</a>).
                </p>

                <h6>Lawful Basis of Processing and Consent for End Customer data</h6>
                <p>
                    <b>End-Customer:</b>
                    Consent is given by the End Customer's acceptance when they grant access to their data through the
                    authorization process, whether via Unified's
                    API Token authorization page, or via an integration vendor's OAuth6 authorization page. The End Customer
                    can withdraw their authorization by
                    contacting our customer (the data processor) or by contacting Unified's support team (<a href="/contact"
                        class="underline">https://unified.to/contact</a>)
                </p>

                <p>
                    <b>Customer:</b>
                    Consent is given by the Customer, which gives Unified permission to process personal data for the
                    purpose of providing the Service to their
                    End-Customers.
                </p>

                <h6>Withdrawal of consent (opt out)</h6>
                <p>
                    <b>Customer:</b>
                    For Customers, withdrawal of consent after initial consent/opt-in is available via termination of their
                    agreement with Unified.
                </p>
                <p>
                    <b>End-Customer:</b>
                    For End-Customers who have authorized an account with Unified through a Customer's application,
                    withdrawal of consent may be accomplished by
                    removing their consent on the Customer's application where they originally granted access.
                </p>

                <h6>Deletion policy</h6>
                <p>
                    <b>Customer:</b>
                    For Customers, deletion of their account's data is available via termination of their agreement with
                    Unified.
                </p>
                <p>
                    <b>End-Customer:</b>
                    For End-Customers, as there is NO data stored on Unified's resources, no action is required. They may
                    contact the Customer where their data
                    maybe stored in the Customer's application.
                </p>

                <h6>Data Access / Modification / Portability</h6>
                <p><b>Customers</b> can access, modify and download their data directly from the Unified application.</p>
                <p><b>End-Customers</b> will need to contact the Customer as none of their data is stored on Unified's
                    resources.</p>

                <h6>Security Controls</h6>
                <p>
                    Unified maintains a strong set of security posture and features. For more details, please visit
                    <a href="/security">https://unified.to/security</a>.
                </p>

                <h6>Notification of Data Breach</h6>

                <p>Please contact us via our Support page at <a href="/contact">https://unified.to/contact</a>.</p>

                <h6>Data Processing Agreement (DPA)</h6>
                <p>Our DPA is available <a href="/gdpr/dpa">here</a>.</p>

                <h6>Sub-Processors</h6>
                <p>Our list of sub-processors is available <a href="/gdpr/subprocessors">here</a>.</p>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { setTitle } from '~~/services/common';

setTitle(
    'GDPR',
    'Unified.to GDPR compliance overview, including our Data Protection Agreement, data handling practices, and sub-processors.'
);
</script>

<style scoped>
h6 {
    font-weight: bold;
    margin-bottom: 20px;
    margin-top: 20px;
}

p {
    margin-bottom: 10px;
    color: var(--medium-gray);
}

ul {
    padding-left: 40px;
    margin-top: 20px;
    list-style: disc;
}

ul li {
    margin-bottom: 10px;
}

a {
    text-decoration: underline;
}
</style>